import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';

const AboutSection = () => {
    const [content, setContent] = useState({ 
        aboutTitle: 'MAIS QUE UMA BARBEARIA, UM LEGADO.', 
        aboutSubtitle: 'A carregar texto...',
        aboutImageUrl: '',
        aboutImageAlt: '' // Descrição da imagem para SEO
    });
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchContent = async () => {
            const docRef = doc(db, "siteContent", "main");
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                setContent(prev => ({ ...prev, ...docSnap.data() }));
            }
            setIsLoading(false);
        };
        fetchContent();
    }, []);

    if (isLoading) {
        return <section id="sobre" className="py-20 md:py-32 bg-background"></section> // Placeholder
    }

    return (
        <section id="sobre" className="py-20 md:py-32">
            <div className="container mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">
                <div className="order-2 md:order-1">
                    <h2 className="text-3xl md:text-4xl font-bold mb-4 text-primary">{content.aboutTitle}</h2>
                    <p className="text-text/80 mb-4 leading-relaxed whitespace-pre-line">
                        {content.aboutSubtitle}
                    </p>
                </div>
                <div className="order-1 md:order-2">
                    {content.aboutImageUrl && (
                        <img 
                            src={content.aboutImageUrl} 
                            alt={content.aboutImageAlt || content.aboutTitle} // Usa a descrição de SEO, com fallback para o título da secção
                            className="rounded-lg shadow-2xl w-full h-auto object-cover" 
                        />
                    )}
                </div>
            </div>
        </section>
    );
};

export default AboutSection;
